import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import {Col, Row} from "antd";
import IconButton from "@material-ui/core/IconButton";
import {useMemo, useState} from "react";
import {nanoid} from "@reduxjs/toolkit";
import {toast} from "react-toastify";
import CloseIcon from "@material-ui/icons/Close";
import FormElement from "./Form.VendorFormModal";

const baseStruct = {
    Name: '',
    Email: '',
    RespEmail: '',
    Tel: '',
}

const initialData = {
    ...baseStruct,
    Stores: []
}

export default function VendorFormModal({
                                            onSubmit,
                                            onClose,
                                            vendor,
                                            show = false,
                                            title = 'Vendor Form',
                                            isLoading = false
                                        }) {
    const [data, setData] = useState(vendor ?? initialData)

    const cleanData = useMemo(() => {
        let copy = {};

        for (const dummyDataKey in baseStruct) {
            copy[dummyDataKey] = data[dummyDataKey]
        }

        copy.Stores = data.Stores.map(store => {
            let storeCopy = {}

            for (const dummyDataKey in store) {
                storeCopy[dummyDataKey] = store[dummyDataKey]
            }

            return storeCopy
        })

        return copy

    }, [data])

    const handleVendorDataChange = (change) => {
        setData({...data, ...change})
    }

    const handleStoreChange = (change, index) => {
        setData({
            ...data, Stores: data.Stores.map((store, idx) => {
                if (idx === index) return change
                return store
            })
        })
    }

    const handleStoreDeletion = (index) => {
        setData({...data, Stores: data.Stores.filter((value, idx) => idx !== index)})
    }

    const handleAddStore = () => setData({...data, Stores: [...data.Stores, {key: nanoid(), ...baseStruct}]})

    const handleClose = () => {
        onClose && onClose()
    }


    const handleSubmit = () => {
        let isValid = true;

        if (("_error" in data) && data._error === true) {
            isValid = false
        }

        for (const dummyDataKey in baseStruct) {
            if (data[dummyDataKey].length === 0) isValid = false
        }

        data.Stores.forEach(store => {

            if (("_error" in store) && store._error === true) {
                //console.log('asdf')

                isValid = false
            }

            for (const dummyDataKey in baseStruct) {
                if (store[dummyDataKey].length === 0) isValid = false
            }
        })

        if (!isValid) toast.error('Tous les champs sont obligatoire')

        isValid && onSubmit && onSubmit(cleanData)
    }


    return (
        <Dialog open={show} maxWidth='md' fullWidth>

            <DialogTitle>
                <Row justify='space-between'>
                    <Col style={{paddingTop: 3}}>
                        {title}
                    </Col>
                    <Col>
                        <IconButton onClick={handleClose}>
                            <CloseIcon/>
                        </IconButton>
                    </Col>
                </Row>
            </DialogTitle>

            <DialogContent>

                <FormElement value={data} onchange={handleVendorDataChange} hideDeleteBtn/>

                {
                    data.Stores.length > 0 && (
                        <Row>
                            <Col style={{marginLeft: 30, marginTop: 30}}>
                                <h5>Stores</h5>
                            </Col>
                        </Row>
                    )
                }

                {
                    data.Stores.map((store, index) => (
                        <FormElement
                            key={store.key}
                            value={store}
                            onchange={change => handleStoreChange(change, index)}
                            onDelete={() => handleStoreDeletion(index)}
                        />
                    ))
                }

                <Row justify='center' style={{marginTop: 20}}>
                    <Button color='primary' onClick={handleAddStore}>
                        Ajouter un store
                    </Button>
                </Row>

            </DialogContent>
            <DialogActions>
                <Button color='primary' variant='contained' onClick={handleSubmit} disabled={isLoading}>
                    Valider
                </Button>
            </DialogActions>
        </Dialog>
    )

}